import React from 'react';
import './ratechangenotification.scss';
import RateChangeNotificationDetails from './RateChangeNotificationDetails';

/** @import { RateChangeNotificationProps, RateChange } from "./RateChangeNotificationTypes" */

class RateChangeNotification extends React.Component {

    constructor(/** @type {RateChangeNotificationProps} */ props) {
        super(props);
    }

    toggelRateChangeNotification = () => {
        this.props.setRateChangeNotification();
    };

    render() {
        const { isRateNotificationVisible, rateChangeList, flipped } = this.props;

        return (
            <div className={!flipped ? "notification__infocontainer" : "notification__infocontainerhide"}>
                <div className="notification__content">
                    <div className="notification__contentarea">
                        <div className="notification__icontext">
                            <svg className="notification__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.999 8C11.861 8 11.749 8.112 11.75 8.25C11.75 8.388 11.862 8.5 12 8.5C12.138 8.5 12.25 8.388 12.25 8.25C12.25 8.112 12.138 8 11.999 8" stroke="#1463AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z" stroke="#1463AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 12V17" stroke="#1463AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div className="notification__textcontainer">
                                <h2 className="notification__title">Your savings rate is decreasing</h2>
                                <div className="notification__hideratechanges">
                                    <div className="notification__hideratechangestext" onClick={this.toggelRateChangeNotification}>
                                        <span>
                                            {isRateNotificationVisible ? 'Hide rate changes' : 'Show rate changes'}</span>
                                        <i className={isRateNotificationVisible ? "arrow up" : "arrow down"}></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className={isRateNotificationVisible ? "notification__description" : "notification__descriptioncollapsed"}>
                        You don't need to do anything, the new interest rate will be applied automatically.
                    </p>
                    <table className={isRateNotificationVisible ? "notification__ratetable" : "notification__ratetablecollapsed"}>
                        <tr className="notification__tableheader">
                            <tr className={isRateNotificationVisible ? "notification__tablerow" : "notification__tablerowcollapsed"}>
                                <th className="notification__cellcontent">New rate</th>
                                <th className="notification__cellcontent">Effective from</th>
                            </tr>
                        </tr>
                        {rateChangeList.map((/** @type {RateChange} */ change, /** @type {number} */ index) => (
                            <RateChangeNotificationDetails key={index} aerRate={change.aerRate} rate={change.rate} isRateNotificationVisible={isRateNotificationVisible} effectiveDate={change.scheduledFor} />
                        ))}
                    </table>
                    <p className={isRateNotificationVisible ? "notification__description_note" : "notification__descriptioncollapsed"}>
                        You'll earn the applicable interest rate as of the effective date specified above on your entire balance when it's between £5,000 - £250,000.
                    </p>
                </div>
            </div>
        );
    }
}

export default RateChangeNotification;